const styles = {
  root: {
    my: { xs: 1, md: 0 },
  },
  container: {
    backgroundColor: 'common.white',
    paddingY: { xs: 2, md: 7 },
    paddingX: 2,
    border: 1,
    borderColor: 'background.border',
    textAlign: 'center',
    boxShadow: '0px 0px 0px 0px rgba(120, 120, 120, 0.03), 0px 3px 6px 0px rgba(120, 120, 120, 0.03), 0px 11px 11px 0px rgba(120, 120, 120, 0.03), 0px 24px 14px 0px rgba(120, 120, 120, 0.02), 0px 42px 17px 0px rgba(120, 120, 120, 0.01), 0px 66px 18px 0px rgba(120, 120, 120, 0.00)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  item: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: { xs: 2, lg: 0 },
    textAlign: 'left',
    border: 1,
    borderColor: 'background.grey400',
    borderRadius: 1,
    pl: 1,
    pb: 1,
  },
  itemContainer: {
    mt: { xs: 1, md: 3 },
  },
  title: {
    mb: { xs: 0, md: 1 },
    '&.alignText': {
      textAlign: 'left',
    },
  },
  childrenContainer: {
    '& .MuiBox-root': {
      margin: '0 auto',
    },
  },
  tag: {
    backgroundColor: 'success.light',
    px: 1,
    py: 0.5,
    alignSelf: 'flex-end',
  },
  icons: {
    pl: { xs: 0.6, md: 1 },
  },
  cardTitle: {
    pt: { xs: 0, lg: 1 },
    pl: { xs: 1, lg: 1 },
  },
  cardDescription: {
    pt: { xs: 1, lg: 0 },
    pb: 1,
    px: 1,
  },
}
export default styles
